import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap';
import duckify from '../../utils/duckify';
import { listPageConfigs, listPageConfigsFields, flashMessages } from '../../ducks';
import Placeholder from '../Placeholder';
import ListPageConfigSelect from './ListPageConfigSelect';
import FlashRoot from '../FlashMessage/FlashRoot';

function ListPageConfig({listPageConfigs, listPageConfigsFields, updateConfigs, showFlash, allDucksReady}) {
  const [buttonText, setButtonText] = useState('Submit')
  const [disableSubmit, setDisableSubmit] = useState(false)
  const [pages, setPages] = useState([])
  const [pageConfigs, setPageConfigs] = useState({})
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if(allDucksReady){
      let pageConfigObj = {}
      listPageConfigs.forEach(config => {pageConfigObj[config.page] = config.additional_fields})

      setPages(listPageConfigs.map(config => config.page))
      setPageConfigs(pageConfigObj)
      setOptions(flattenGroupedOptions(listPageConfigsFields))
    }
  }, [allDucksReady])

  const flattenGroupedOptions = (options) => {
    const flattened = [];
    options.forEach(option => {
      if(option.options) {
        flattened.push({...option, value: "__GROUP__", group: true, disabled: true});
        option.options.forEach(opt => flattened.push(opt));
      } else {
        flattened.push(option);
      }
    });

    return flattened;
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    setDisableSubmit(true)
    setButtonText('Submitting...')
    
    let dataArray = []
    
    pages.forEach(page => {
      dataArray.push({page: page, additional_fields: pageConfigs[page]})
    })

    updateConfigs(dataArray)
      .then(() => {
        showFlash({
          message: `Saved`,
        })
      })
      .catch(error => {
        showFlash({
          message: `Submit failed with error: ${error.response.statusText} - Status: ${error.response.status}`,
          type: 'danger'
        })
      })
      .then(() => {
        setButtonText('Submit')
        setDisableSubmit(false)
      })
  }

  const updateSelected = (page, selected) => {
    const fields = selected.map(field => {
      return field.value
    })

    setPageConfigs({...pageConfigs, [page]: fields})
  }

  return (
    <div id='list-page-config' className='setup'>
      <FlashRoot />
      <h2>List Page Configurations</h2>
      {allDucksReady ?
        <Form>
          {listPageConfigs.length > 0 ?
            <React.Fragment>
              {listPageConfigs.map((config, index) => {
                return (
                  <ListPageConfigSelect
                    key={index}
                    page={config.page}
                    value={config.additional_fields}
                    options={options}
                    onChange={updateSelected}
                  />)
              })}
              <input onClick={handleSubmit} disabled={disableSubmit} type='submit' value={buttonText} className='btn btn-primary'/>
            </React.Fragment>: 'No list pages to configure'}
        </Form> :
        <Placeholder.loading/>}
    </div>
  )
}

const mapDucksToProps = () => {
  return {
    listPageConfigs: listPageConfigs,
    listPageConfigsFields: listPageConfigsFields
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  updateConfigs: (configs) => dispatch(listPageConfigs.actions.bulkUpdate(configs)),
  showFlash: (props) => dispatch(flashMessages.actions.show(props)),
});

export default duckify(mapDucksToProps, () => {}, mapDispatchToProps)(ListPageConfig);